import i18next from 'i18next';

i18next.addResources('es', 'LegalCasesTable', {
  number: 'N° Expediente',
  credentials: 'Credenciales',
  jurisdiction: 'Jurisdicción',
  cover: 'Carátula',
  status: 'Estado',
  lastAction: 'Últ. Act.',
  today: 'Hoy',
  favorite: 'Destacado',
  notFavorite: 'Sin destacar',
  favoriteAddedSuccess: 'Expediente agregado a destacados',
  favoriteRemovedSuccess: 'Expediente quitado de destacados',
  favoriteError: 'No se pudo actualizar el destacado',
  showing: 'Mostrando {{count}} de {{total}} resultados',
  of: 'de',
  loadMore: 'Cargar más',
  loading: 'Cargando...',
  empty: 'No se encontraron expedientes',
  searchPlaceholder: 'Buscar por número, carátula',
  importInProgress: 'En proceso de importación',
  updateInProgress: 'En proceso de actualización',
  type: 'Tipo',
  matter: 'Materia',
  manualSearchPlaceholder: 'Buscar por carátula, tipo, materia o estado...',
  assignees: 'Asignados',
  noAssignees: 'Sin asignar',
  filterJurisdiction: 'Jurisdicciones',
  filterJurisdictionSearch: 'Buscar jurisdicción...',
  filterJurisdictionEmpty: 'No se encontraron jurisdicciones',
  filterStatus: 'Estados',
  filterStatusSearch: 'Buscar estado...',
  filterStatusEmpty: 'No se encontraron estados',
  filterLastAction: 'Últ. actuación PJN',
  filterType: 'Tipos',
  filterTypeSearch: 'Buscar tipo...',
  filterTypeEmpty: 'No se encontraron tipos',
  filterMatter: 'Materias',
  filterMatterSearch: 'Buscar materia...',
  filterMatterEmpty: 'No se encontraron materias',
  filterTags: 'Etiquetas',
  filterTagsSearch: 'Buscar etiqueta...',
  filterTagsEmpty: 'No se encontraron etiquetas',
  actions: 'Acciones',
  syncCase: 'Sincronizar expediente'
});
